import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <path
          className="icon-color"
          d="M9.036 14.362l.008 1.342c0 .151.123.273.274.273h1.333c.073 0 .143-.029.195-.08l4.028-4.029c.158-.158.158-.415 0-.573l-1.182-1.182c-.144-.144-.378-.144-.522 0l-4.053 4.053c-.052.052-.08.123-.08.196"
        />
        <path
          className="icon-color"
          d="M9.007 5.002V2.805l2.17 2.197h-2.17zm4.99.26c0-.162-.062-.317-.177-.43L9.226.182C9.11.065 8.952 0 8.788 0H3.5C2.672 0 2 .627 2 1.4v13.2c0 .773.672 1.4 1.5 1.4h3.492v-.003h.003c.552 0 1-.448 1-1s-.448-1-1-1c-.005 0-.01.003-.013.003H4V2h3.007v3.323c0 .926.754 1.68 1.68 1.68h3.31v.994c0 .552.448 1 1 1 .55 0 .998-.447.999-.998V5.261z"
        />
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <path
          className="icon-color"
          d="M12.392 20.384l.007 1.342c.001.151.123.273.274.273h1.333c.073 0 .143-.029.195-.08l4.028-4.029c.158-.158.158-.415 0-.573l-1.182-1.182c-.144-.144-.378-.144-.522 0l-4.053 4.054c-.052.051-.08.122-.08.195M19.434 16.685l1.48-1.478c.11-.11.11-.292 0-.403l-1.328-1.327c-.11-.11-.292-.11-.403 0l-1.478 1.48c-.112.11-.112.291 0 .402l1.327 1.326c.111.111.291.111.402 0M12.998 8.02V4.83l3.178 3.174-3.177.016zM19 11V8.371c0-.24-.096-.469-.265-.638l-5.432-5.427C13.104 2.11 12.838 2 12.56 2h-7.56c-1.107 0-2 .895-2 2v16c0 1.104.893 2 2 2h3.988l.011.002c.553 0 1-.448 1-1s-.447-1-1-1V20H5V4h5.998v4.02c0 1.09.889 1.975 1.98 1.975H17v1.01h.003c.006.547.448.99.997.99.55 0 .994-.443.998-.99H19v-.006z"
        />
      </g>
    </svg>
  ),
};
